/**
 * 查询用户充值明细。
 * @author 王振宇
 * @since 2022-08-12
 */
export default (function (_ref) {
  var service = _ref.service,
    request = _ref.request,
    serviceForMock = _ref.serviceForMock,
    requestForMock = _ref.requestForMock,
    mock = _ref.mock,
    faker = _ref.faker,
    tools = _ref.tools;
  return {
    GET_MEMBER_RECHARGE_DETAILED_LIST_PAGE_LIST: function GET_MEMBER_RECHARGE_DETAILED_LIST_PAGE_LIST() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/statistics/getMemberRechargeDetailedList',
        method: 'post',
        data: data
      });
    },
    GET_MEMBER_MEMBER_VISITOR_PAGE_LIST: function GET_MEMBER_MEMBER_VISITOR_PAGE_LIST() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/MemberVisitor/getPageList',
        method: 'post',
        data: data
      });
    }
  };
});